var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.4428C22.4422 10.6875 21.8478 10.8497 21.2281 10.9284C21.8656 10.5478 22.3522 9.94969 22.5809 9.22875C21.9866 9.58312 21.3303 9.83344 20.6309 9.97313C20.0666 9.37219 19.2622 9 18.3847 9C16.6822 9 15.3116 10.3819 15.3116 12.0759C15.3116 12.3197 15.3322 12.5541 15.3828 12.7772C12.8263 12.6525 10.5641 11.4272 9.04437 9.56063C8.77906 10.0209 8.62344 10.5478 8.62344 11.115C8.62344 12.18 9.17188 13.1241 9.98937 13.6706C9.49531 13.6613 9.01063 13.5178 8.6 13.2919C8.6 13.3012 8.6 13.3134 8.6 13.3256C8.6 14.82 9.66594 16.0612 11.0637 16.3472C10.8134 16.4156 10.5406 16.4484 10.2575 16.4484C10.0606 16.4484 9.86187 16.4372 9.67531 16.3959C10.0738 17.6137 11.2044 18.5091 12.5488 18.5381C11.5025 19.3566 10.1741 19.8497 8.73594 19.8497C8.48375 19.8497 8.24187 19.8384 8 19.8075C9.36219 20.6859 10.9766 21.1875 12.7175 21.1875C18.3763 21.1875 21.47 16.5 21.47 12.4369C21.47 12.3009 21.4653 12.1697 21.4587 12.0394C22.0691 11.6063 22.5819 11.0653 23 10.4428Z",
    fill: "#F9A12C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3794c4bb13c27e69d9e35e86e5d98893.svg";
export { ForwardRef as ReactComponent };